export default function submitsColumn() {
    return {
		name: 'numSubmits',
		label: 'Num Submits',
		options: {
            filter: false,
			setCellProps: () => ({ sx: { textAlign: "center" } })
		}
	}
}